import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { ClaimsService } from '../../../../services/claims.service';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { ReferralDataService } from '../../../../services/referral-data.service';
import { SectionsService } from '../../../../services/sections.service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { UserService } from '../../../../services/user.service';
import { AutoFocusHeaderDirective } from '../../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-service-code-list',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent, AutoFocusHeaderDirective],
  templateUrl: './service-code-list.component.html',
  styleUrl: './service-code-list.component.css',
})
export class ServiceCodeListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_SERVICE_CODE_DATA;
  pageId: string = PAGE_CONSTANTS.SERVICE_CODE_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router, private sectionService: SectionsService, private referralDataService: ReferralDataService,
    private leadDetailsService: LeadDetailsService,private sharedDataService: SharedDataService, private authUtility: AuthorizationUtility,
    private authService: AuthorizationService, private claimsService: ClaimsService, private userService: UserService
  ) {
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  onAddServiceCode() {
    this.sectionService.setFlow('serviceCode');
    this.userService.setLeadEntry('serviceCode');
    this.userService.setSelectedId(null);
    this.router.navigate(['/home/serviceCode', 'add']);
  }

  rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('serviceCode');
    this.sectionService.setFlow('serviceCode');
    this.userService.setSelectedId(rowDetail.serviceCodeDetailId);
      this.claimsService.fetchClaimsData(
          program?.program_code ?? '',
          rowDetail.serviceCodeDetailId,
          'serviceCode'
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('service_code', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/serviceCode', 'update']);
          }, 200);
        });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.programName, this.pageId, "LIST").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(pageConfig, this.pageId);
      this.actionsToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
    }
    this.isPageRestrictionLoaded = true;
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
